/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "bootstrap/dist/js/bootstrap";
import jQuery from "jquery";
import 'jquery-ui-dist/jquery-ui.js';
import 'jquery-ui-dist/jquery-ui.css';

import "../src/stylesheets/stylesheet.scss";
import "controllers"

global.$ = global.jQuery = jQuery;

require("rails-ujs").start();
require("turbolinks").start();

import moment from "moment";
window.moment = moment;
require("tempusdominus-bootstrap-4");
import "tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4";

$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
  icons: {
    time: 'mdi mdi-clock-outline',
    date: 'mdi mdi-calendar',
    up: 'mdi mdi-arrow-up',
    down: 'mdi mdi-arrow-down',
    previous: 'mdi mdi-chevron-left',
    next: 'mdi mdi-chevron-right',
    today: 'mdi mdi-calendar-check-outline',
    clear: 'mdi mdi-delete',
    close: 'mdi mdi-times'
  }
});

function onLoad() {
  $('div.input-group.date').each(function(i, e){
    const date_div=$(e);
    const date_input = date_div.find('input');
    date_div.datetimepicker('destroy');
    const current_value = date_input.attr('value');
    const min_date = date_input.attr('min');
    const max_date = date_input.attr('max');

    const date_options = {allowInputToggle: true, viewMode: (date_div.data('view-mode') || 'months'), format: (date_div.data('format') || 'DD/MM/YYYY')};
    if (current_value) {
      date_options["defaultDate"] = moment(current_value);
      date_options["date"] = moment(current_value);
    }
    if (min_date) {
      date_options["minDate"] = moment(min_date);
    }
    if (max_date) {
      date_options["maxDate"] = moment(max_date);
    }

    date_div.datetimepicker(date_options);
  });

  $('select').each(function(i, e){
    const dropdown=$(e);
    const placeholder_text=dropdown.attr('placeholder');
    const options = {}
    if (dropdown.data('ajax-url')) {
      options["ajax"] = {delay: 250, dataType: "json"}
      options["minimumInputLength"] = 3
    }
    if (placeholder_text) {
      options['placeholder'] = placeholder_text
      options['allowClear'] = true
    }
  });
  $('[title]').tooltip();

}

$(document).on('turbolinks:load', onLoad);
